import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import Pdf from "../../../components/pdf/Pdf";
import OrderSlip from "./OrderSlip";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import useSave from "../../../Hooks/useSave";

export default function App() {
  const { id } = useParams();

  const { fetchGraphql } = useSave();

  const [invoice, setInvoice] = React.useState({});
  const [products, setProducts] = React.useState([]);

  useEffect(() => {
    fetchGraphql({
      query: `query Invoices($invoiceId: ID!) {
        invoiceLineItems(invoiceId: $invoiceId) {
          invoiceLineItemId
          invoiceId
          productId
          productName
          price
          quantity
          packedWeight
          combinedId
          priceByPound
        }
        invoice(invoiceId: $invoiceId) {
          invoiceId
          invoiceDate
          deliveryDate
          orderId
          customerName
          paymentStatus
          invoiceNote
          discountAmount
          discountType
          createdBy
          lastEditedBy
          billingAddress {
            addressId
            addressLine
            addressLine2
            city
            state
            zip
            comments
          }
          shippingAddress {
            addressId
            addressLine
            addressLine2
            city
            state
            zip
            comments
          }
        }
      }`,
      variables: { invoiceId: id },
    }).then((result) => {
      setInvoice(result.data.invoice);
      setProducts(result.data.invoiceLineItems);

      console.log(result);
    });
  }, []);

  const groupBy = (items, key) => {
    return items?.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  };

  const groupedProducts = groupBy(
    products?.filter((item) => item.combinedId > 0),
    "combinedId"
  );

  console.log("groupedProducts", groupedProducts);
  return (
    <PDFViewer width="100%" height="100%">
      <OrderSlip
        invoice={invoice}
        products={products}
        groupedProducts={groupedProducts}
      />
    </PDFViewer>
  );
}
